/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from "../runtime";
/**
 * Check if a given object implements the Equipment interface.
 */
export function instanceOfEquipment(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
export function EquipmentFromJSON(json) {
    return EquipmentFromJSONTyped(json, false);
}
export function EquipmentFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json.id,
        name: !exists(json, "name") ? undefined : json.name,
    };
}
export function EquipmentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        name: value.name,
    };
}
